import styles from "./why-choose-doomum.module.css";
import {
  LuGlobe,
  LuStar,
  LuSearch,
  LuShieldCheck,
  LuHeadset,
} from "react-icons/lu";

function FeatureItem({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) {
  return (
    <div className={styles.featureItem}>
      <div className={styles.iconWrapper}>{icon}</div>
      <div className={styles.textWrapper}>
        <h4 className={styles.featureTitle}>{title}</h4>
        <p className={styles.featureDesc}>{description}</p>
      </div>
    </div>
  );
}

export default function WhyChooseDoomum() {
  return (
    <section className={styles.wrapper}>
      <div className={styles.leftColumn}>
        <h3 className={styles.title}>
          Why thousands
          <br />
          choose Doomum
        </h3>
      </div>

      <div className={styles.rightColumn}>
        <FeatureItem
          icon={<LuGlobe />}
          title="Global Reach, Local Expertise"
          description="Trusted agents in 100+ countries."
        />
        <FeatureItem
          icon={<LuStar />}
          title="Verified Listings"
          description="Every property is verified for your peace of mind."
        />
        <FeatureItem
          icon={<LuSearch />}
          title="Smart Search Technology"
          description="Find the right property faster with AI-powered search."
        />
        <FeatureItem
          icon={<LuShieldCheck />}
          title="Secure Transactions"
          description="Your data and investments are always protected."
        />
        <FeatureItem
          icon={<LuHeadset />}
          title="Dedicated Support"
          description="Real people. Real support. Every step of the way."
        />
      </div>
    </section>
  );
}
